import React, { FC } from 'react';
import TemplateMedia from './TemplateMedia';
import { PolicyTemplateTypeId } from '../../../../types/policies';
import FavoriteIndicator from './FavoriteIndicator';
import PolicyTemplateImage from '../../Images/policy_template.png';
import TemplateChips, { TemplateChipsProps } from './TemplateChips';
import { Icon, Icons } from '@silverfort/sf-components';

type Props = TemplateChipsProps & {
    name: string;
    isFavorite: boolean;
    description: string;
    type: PolicyTemplateTypeId;
    disclaimer?: string;
    hideSpnChips?: boolean;
};

const TemplateDetails: FC<Props> = ({
    name,
    description,
    isFavorite,
    type,
    spns,
    authTypes,
    protocols,
    risks,
    disclaimer,
    hideSpnChips = false
}) => (
    <div className="min-h-[170px] w-full max-w-full rounded-[24px] border border-sf-gray-100 overflow-hidden flex">
        <div className="m-6 flex flex-col justify-center gap-4 flex-1 max-w-[calc(100%-232px)] overflow-hidden">
            <div className="flex flex-col items-start gap-1">
                <span className="font-sf-poppins font-bold text-15 leading-[18px] tracking-[0.018rem]">{name}</span>
                <span className="font-sf text-12 font-normal text-sf-gray-500 leading-[14.32px]">{description}</span>
            </div>
            <TemplateChips showLabels spns={spns} authTypes={authTypes} protocols={protocols} risks={risks} hideSpnChips={hideSpnChips}/>
            {disclaimer && (
                <div className="flex gap-2 items-center">
                    <Icon
                        icon={Icons.CircleInfo}
                        className="bg-sf-primary-100 rounded-[5px] p-[2.5px] text-sf-primary-500"
                        size={15}
                    />
                    <span className="font-sf text-12 leading-[14.32px] text-sf-gray-500">{disclaimer}</span>
                </div>
            )}
        </div>
        <div className="min-w-[232px] max-w-[232px]">
            <TemplateMedia type={type}>
                <div className="relative w-full h-full">
                    <img
                        alt=""
                        src={PolicyTemplateImage}
                        className="relative top-[50px] left-[60px] min-w-[415.47px] resize-none rounded-[8px] rotate-[-15deg] shadow-[0px_8px_12px_0px_#0000001A]"
                    />
                    <div className="absolute top-4 right-4">
                        <FavoriteIndicator isFavorite={isFavorite} />
                    </div>
                </div>
            </TemplateMedia>
        </div>
    </div>
);

export default TemplateDetails;
